import React, {useCallback, useEffect, useState} from "react";
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import "react-toastify/dist/ReactToastify.css";
import Button from "react-bootstrap/Button";
import RightModal from "./modalForm";

// hooks
import { useRedux, useHistory, useSearchInput } from "../../../hooks";

import {
    editDataSalePaymentSystem,
    getSalePaymentSystems,
    onRemoveSalePaymentSystem,
    removeSalePaymentSystemModalHide,
    removeSalePaymentSystemModalShow,
    showRightModalSalePaymentSystem
} from "../../../redux/actions";

import TableList from "../../../components/TableList";
import SalePaymentSystemColumns from "./tableColumns";
import {PaymentSystemType} from "../../../redux/Sale/PaymentSystem/types";
import {EntityActionsHandlersType} from "../../../redux/types";
import RemoveModal from "../../../components/RemoveForm";

import '../../../i18/config';
import {useTranslation} from "react-i18next";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import Loader from "../../../components/Loader";
import MainListFilter from "../../../components/MainListFilter";

const SalePaymentSystemIndex = () => {
    const { dispatch, useAppSelector } = useRedux();

    const { t } = useTranslation(['common']);

    const componentType = 'salePaymentSystemTable';

    const {
        historyHash,
        searchPhrase,
        loadItems,
        handleSearchClick
    } = useHistory({
        componentType,
        loadAction: getSalePaymentSystems,
        dispatch
    });

    const { onSearchInput } = useSearchInput(handleSearchClick);

    const {
        salePaymentSystem,
        isFetched
    } = useAppSelector(state => ({
        salePaymentSystem: state.SalePaymentSystem,
        isFetched: state.SalePaymentSystem.isFetched
    }));

    const openRightModal = useCallback((event:any) => {
        if ((event !== undefined) && (event.uuid !== undefined) && (event.uuid.length>0)){
            dispatch(editDataSalePaymentSystem({data:event, modalEditTitle: 'changePaymentSystem'}));
        } else {
            dispatch(showRightModalSalePaymentSystem({data:[], modalEditTitle: 'newPaymentSystem'}));
        }
    },[dispatch]);

    const onEntityRemoveModalShow = useCallback((event:any) => {
        if ((event !== undefined) && (event.uuid !== undefined) && (event.uuid.length>0)){
            dispatch(removeSalePaymentSystemModalShow({data:event, modalEditTitle: 'deletePaymentSystem'}));
        }
    },[dispatch]);

    const onEntityRemoveModalHide = useCallback(() => dispatch(removeSalePaymentSystemModalHide()),[dispatch]);

    const onEntityRemove = useCallback((event:any) => {
        if ((event !== undefined) && (event.uuid !== undefined) && (event.uuid.length>0)){
            dispatch(onRemoveSalePaymentSystem({data:event, modalEditTitle: 'deletePaymentSystem'}));
        }
    },[dispatch]);

    useEffect(() => {
        if(salePaymentSystem.isNeedReload){
            loadItems();
        }
    }, [loadItems, salePaymentSystem.isNeedReload]);

    const EntityActionsHandlers:EntityActionsHandlersType = {
        onEdit: openRightModal,
        onRemove: onEntityRemoveModalShow
    }

    const onTableRowClick = useCallback((item:PaymentSystemType) => {
        if (item.actions && item.actions.canEdit){
            openRightModal(item);
        }
    },[openRightModal]);

    const columns = SalePaymentSystemColumns(EntityActionsHandlers);

    return (
        <>
            <BreadCrumb title={t('menu:paymentSystems')} pageTitle={t('menu:main')} />
                <Row className="g-4 mb-3">
                    <div className="col-sm-auto">
                        <div>
                            <Button variant="secondary" onClick={openRightModal} className="btn btn-success">
                                <i className="ri-add-line align-bottom me-1"/> {t('common:addNew')}
                            </Button>
                        </div>
                    </div>
                </Row>

                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardHeader className="border-bottom-0">
                                <h5 className="card-title mb-0">{t('payment:paymentSystems')}</h5>
                            </CardHeader>
                            <CardBody className="border border-dashed border-end-0 border-start-0 pb-3">
                                <MainListFilter
                                    onClick={handleSearchClick}
                                    value={searchPhrase}
                                    onChange={onSearchInput}
                                />
                            </CardBody>
                            <CardBody>
                                {isFetched ?
                                    <TableList
                                    columns={columns}
                                    data={salePaymentSystem.items}
                                    onRowClick={onTableRowClick}
                                    key={componentType}
                                    historyHash = {historyHash}
                                    paginationTotalRows={salePaymentSystem?.meta?.totalCount || 0}
                                    paginationServer={true}
                                    isShowChangePageSize={true}
                                    />
                                    :
                                    <Loader/>
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <RightModal/>
                <RemoveModal
                    onRemove={onEntityRemove}
                    handleClose={onEntityRemoveModalHide}
                    removeItem={salePaymentSystem.selectedItem}
                    isOpen={salePaymentSystem.removeModalShow}
                    modalTitle={salePaymentSystem.modalEditTitle}/>
        </>
    );
};

export default SalePaymentSystemIndex;


